const BOOKING_FORM_SELECTOR = "form[data-booking-form]";
const SINGLE_SELECT_INITIALISED_ATTRIBUTE = "singleSelectInitialised";
const SINGLE_SELECT_LABEL_SELECTOR = "[data-single-select-label='true']";
const SINGLE_SELECT_OPTION_SELECTOR = "button[data-option-value]";

const DROPDOWN_BUTTON_CLASS_NAME =
  "flex w-full items-center justify-between bg-white p-0 text-left text-[14px] leading-[22px] text-primary-900 focus:outline-none";
const DROPDOWN_MENU_CLASS_NAME =
  "absolute left-0 right-0 top-full z-30 mt-2 hidden max-h-64 overflow-auto rounded-xl border border-neutral-200 bg-white p-1 shadow-sm";
const DROPDOWN_OPTION_CLASS_NAME =
  "w-full rounded-lg px-3 py-2 text-left text-[14px] leading-[22px] text-primary-900 hover:bg-primary-50";

export {
  BOOKING_FORM_SELECTOR,
  SINGLE_SELECT_INITIALISED_ATTRIBUTE,
  SINGLE_SELECT_LABEL_SELECTOR,
  SINGLE_SELECT_OPTION_SELECTOR,
  DROPDOWN_BUTTON_CLASS_NAME,
  DROPDOWN_MENU_CLASS_NAME,
  DROPDOWN_OPTION_CLASS_NAME,
};
